import { CheckCircleFilled } from "@ant-design/icons";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  message,
} from "antd";
import { CALL_API } from "common/API";
import COLORS from "common/Colors";
import { LEAVE_ICON, STATUS_CODE, N8N_URL } from "common/Constants";
import { concat, includes, orderBy, reduce } from "lodash";
import AttendanceBarChart from "molecules/AttendanceBarChart";
import DepartmentStaffLeaveBalance from "molecules/DepartmentStaffLeaveBalance";
import LeaveDonutChart from "molecules/LeaveDonutChart";
import LocationBasedPresentStaff from "molecules/LocationBasedPresentStaff";
import moment from "moment";
import LeaveFormModel from "organisms/LeaveFormModel";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { getMySqlDate } from "utils/Date";
import Filter from "../assets/Filter.svg";
import dayjs from "dayjs";
import ViewDocument from "reusableComponent/Popup/viewDocument";
import download from "downloadjs";
import { useSelector } from "react-redux";
import { getUserList } from "redux/selectors";

const StyledRow = styled(Row)`
  padding-top: 20px;
`;

const StyledLeaveRow = styled(Row)`
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px;
  height: 100%;
  margin: 20px;
  @media (max-width: 417px) {
    display: block !important;
    padding-bottom: 10px;
    .leavereportstyle {
      margin-left: 70px;
    }
  }
`;

const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin: 0px !important;
`;

const StyledForm = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .select {
    width: 150px;
  }
`;
const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;

  &:hover {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #141414;
  margin-right: auto;
`;
const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

function ManagerDashboard({
  ClientId,
  selectedDepartmentId,
  userRoleId,
  departmentList,
  roleList,
  AllDepartmentList,
  Menulist,
  leaveCategoryList,
  userList,
  updateSuccessModal,
  // leaveList,
  // setLeaveList,
  userInfo,
  type,
}) {
  console.log("userList---", userList);
  const users = useSelector(getUserList);
  const [leaveCatgeory, setLeaveCatgeory] = useState([]);
  const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
  const [displayLeaveModal, toggleDisplayLeaveModal] = useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [leaveID, setLeaveID] = useState();
  const [havingCancel, sethavingCancel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [staffDepartmentLeaveModal, toggleStaffDepartmentLeaveModal] =
    useState(false);
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [userLeaves, setUserLeaves] = useState([]);
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);
  const csvLinkDepartment = useRef();
  const [leaveList, setLeaveList] = useState([]);
  const [availableLeaves, setAvailableLeaves] = useState([]);
  const [tabId, setTabId] = useState(
    Menulist?.find(
      (item) =>
        item?.key === "allapprovals" &&
        item?.subMenu?.find(
          (subItem) => subItem?.key === "approvals" && subItem?.permission.view
        )
    )
      ? "1"
      : "2"
  );
  const [data, setData] = useState([]);
  const [overtimedata, setovertimeData] = useState([]);
  const [timeOffData, setTimeOffData] = useState([]);
  const [preview, setPreview] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [filterdate, setfilterdate] = useState(dayjs());
  const [requestMonth, setRequestMonth] = useState(null);

  const [form] = Form.useForm();

  const containerRef = useRef(null);

  const [leaveSummary, setLeaveSummary] = useState({});

  const filterRoleList = roleList?.filter(
    (item) => item?.roleId === userRoleId
  );

  const getData = async () => {
    setLoading(true);
    const { code, data } = await CALL_API(
      `employeerequest/wfhrequest?reportingManager=${
        userInfo?.userid
      }&statusId=${"0"}&${getRequestDateRange()}&myteam=true`,
      "get"
    );

    if (code === STATUS_CODE.SUCCESS) {
      setData(data || []);
      setLoading(false);
    }
  };

  const getovertimeData = async () => {
    setLoading(true);
    const { code, data } = await CALL_API(
      `employeerequest/overtimerequest?reportingManager=${
        userInfo?.userid
      }&statusId=${"0"}&${getRequestDateRange()}&myteam=true`,
      "get"
    );

    if (code === STATUS_CODE.SUCCESS) {
      setovertimeData(data || []);
      setLoading(false);
    }
  };

  const getTimeOffData = async () => {
    setLoading(true);
    const { code, data } = await CALL_API(
      `employeerequest/permissionrequest?reportingManager=${
        userInfo?.userid
      }&statusId=${"0"}&${getRequestDateRange()}&myteam=true`,
      "get"
    );

    if (code === STATUS_CODE.SUCCESS) {
      setTimeOffData(data || []);
      setLoading(false);
    }
  };

  const handlePreviewClick = async (data, type) => {
    console.log("data12-->", data);
    try {
      const preview = data?.fileName?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `employeerequest/file?userId=${data?.userId}&requestId=${data?.requestId}&requestType=${type}`,
        "get",
        {}
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const timeOffColumns = [
    {
      title: "Name",
      dataIndex: "userId",
      key: "userId",
      render: (text) => {
        return users?.find((val) => val?.userid === text)?.fullname;
      },
    },
    {
      title: "Employee ID",
      dataIndex: "userId",
      key: "userId",
      render: (text) => {
        return users?.find((val) => val?.userid === text)?.employeeid;
      },
    },
    {
      title: "Date - Day",
      dataIndex: "permissionDate",
      key: "permissionDate",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Time",
      dataIndex: "permissionTime",
      key: "permissionTime",
      render: (date) => {
        return dayjs(date)?.format("HH [hrs] mm [mins]");
      },
    },
    {
      title: "Day to Compensate",
      dataIndex: "compensatingDate",
      key: "compensatingDate",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },

    {
      title: "Attachment",
      dataIndex: "fileName",
      key: "fileName",
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record, "permissionrequest");
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Applied on",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Reason for Time Off in Lieu",
      dataIndex: "permissionReason",
      key: "permissionReason",
      className: "reason-column",
    },
  ];

  const workFromHomecolumns = [
    {
      title: "Name",
      dataIndex: "userId",
      key: "userId",
      render: (text) => {
        return users?.find((val) => val?.userid === text)?.fullname;
      },
    },
    {
      title: "Employee ID",
      dataIndex: "userId",
      key: "userId",
      render: (text) => {
        return users?.find((val) => val?.userid === text)?.employeeid;
      },
    },
    {
      title: "Start Date",
      dataIndex: "wfhStartDate",
      key: "wfhStartDate",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "End Date",
      dataIndex: "wfhEndDate",
      key: "wfhEndDate",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Total Days",
      dataIndex: "wfhNoofDays",
      key: "wfhNoofDays",
    },

    {
      title: "Attachment",
      dataIndex: "fileName",
      key: "fileName",
      render: (text, record) =>
        text ? (
          <a
            href="#"
            style={{ color: "#2d53da" }}
            className="text-wrap"
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record, "wfhrequest");
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Applied on",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Reason for WFH",
      dataIndex: "wfhReason",
      key: "wfhReason",
      className: "reason-column",
    },
  ];

  const overtimecolumns = [
    {
      title: "Name",
      dataIndex: "userId",
      key: "userId",
      width: 150,
      render: (text) => {
        return (
          users?.find((val) => String(val?.userid) === String(text))
            ?.fullname || "-"
        );
      },
    },
    {
      title: "Employee ID",
      dataIndex: "userId",
      key: "userId",
      width: 150,
      render: (text) => {
        return users?.find((val) => val?.userid === text)?.employeeid;
      },
    },
    {
      title: "Date - Day",
      dataIndex: "overtimeDate",
      key: "overtimeDate",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Time",
      dataIndex: "overtimeTime",
      key: "overtimeTime",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("HH [hrs] mm [mins]");
      },
    },

    {
      title: "Attachment",
      dataIndex: "fileName",
      key: "fileName",
      width: 150,
      render: (text, record) => (
        <a
          href="#"
          style={{ color: "#2d53da" }}
          className="text-wrap"
          onClick={(e) => {
            e.stopPropagation();
            handlePreviewClick(record, "overtimerequest");
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Applied on",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Reason for Overtime",
      dataIndex: "overtimeReason",
      key: "reason",
      width: 150,
      className: "reason-column",
    },
  ];

  const filterDepartmentId = selectedDepartmentId;
  const filterDepartment = AllDepartmentList?.filter((item) =>
    filterDepartmentId?.includes(item?.department_id)
  );

  // const getAvailableLeaves = async () => {
  //   try {
  //     const { code, response } = await CALL_API(`employee/node_leave`, "post", {
  //       clientid: ClientId,
  //     });
  //     if (code === STATUS_CODE.SUCCESS) {
  //       setAvailableLeaves(response);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  useEffect(() => {
    const userids = userList
      ?.filter((user) => user?.reportingmanager === userInfo?.userid)
      ?.map((val) => val?.userid);
    let leaveStatistics = {};

    // Initialize leaveStatistics with all categories
    leaveCategoryList.forEach((category) => {
      leaveStatistics[category.leave_category_id] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
      };
    });

    // Check if leaveCatgeory exists
    if (!leaveCatgeory || leaveCatgeory.length === 0) return;

    // Filter approved leaves (status_id === "5") and matching department
    // const approvedLeaves = leaveCatgeory.filter((item) => {
    //   const isDepartmentFiltered = filterDepartment?.some(
    //     (dept) => dept.department_id === item.department_id
    //   );
    //   return (
    //     // isDepartmentFiltered &&
    //     item.status_id === "5" && userids?.includes(item?.userid)
    //   );
    // });

    // Accumulate consumed leave
    // leaveCatgeory.forEach((leave) => {
    //   const leaveCategoryId = leave.categoryid;
    //   console.log("leaveCategoryId-->", leaveCategoryId);

    //   if (!leaveStatistics[leaveCategoryId]) {
    //     leaveStatistics[leaveCategoryId] = { available: 0, consumed: 0 };
    //   }

    //   leaveStatistics[leaveCategoryId].consumed += parseFloat(
    //     leave.consumed || 0
    //   );
    //   leaveStatistics[leaveCategoryId].available += parseFloat(
    //     leave.available || 0
    //   );
    // });
    // Accumulate available leave based on gender and reporting manager
    leaveCategoryList?.forEach((category) => {
      const leaveCategoryId = category.leave_category_id;
      const eligibleGender = category.eligible?.toLowerCase();

      leaveCatgeory?.forEach((categoryDetails) => {
        if (categoryDetails?.categoryid === leaveCategoryId) {
          userList?.forEach((user) => {
            const userGender = user.gender?.toLowerCase();

            const isEligible =
              eligibleGender === "both" || eligibleGender === userGender;

            if (
              categoryDetails?.userid === user.userid &&
              category?.locationId?.includes(user?.baselocationid) &&
              user?.reportingmanager === userInfo?.userid &&
              isEligible
            ) {
              if (!leaveStatistics[leaveCategoryId]) {
                leaveStatistics[leaveCategoryId] = {
                  available: 0,
                  consumed: 0,
                  carryforward: 0,
                };
              }

              leaveStatistics[leaveCategoryId].available += parseFloat(
                categoryDetails.available || 0
              );
              leaveStatistics[leaveCategoryId].consumed += parseFloat(
                categoryDetails.consumed || 0
              );
              leaveStatistics[leaveCategoryId].carryforward += parseFloat(
                categoryDetails.carry_forward || 0
              );
            }
          });
        }
      });
    });
    // Final output to map into chart or UI data
    const updatedLeaveData = leaveCategoryList.map((category) => {
      const leaveCategoryId = category.leave_category_id;

      const userCount = userList.filter((user) => {
        const hasManager = user?.reportingmanager === userInfo?.userid;
        if (!hasManager) return false;

        const eligibleGender = category.eligible?.toLowerCase();
        return (
          eligibleGender === "both" ||
          eligibleGender === user.gender?.toLowerCase()
        );
      }).length;

      return {
        categoryName: category.leave_category_name,
        id: leaveCategoryId,
        userCount: userCount, // optional
        data: [
          {
            type: "available",
            value: leaveStatistics[leaveCategoryId]?.available || 0,
            carryforward: leaveStatistics[leaveCategoryId]?.carryforward || 0,
          },
          {
            type: "consumed",
            value: leaveStatistics[leaveCategoryId]?.consumed || 0,
          },
        ],
      };
    });

    setLeaveSummary(updatedLeaveData);
    setUserLeaves(updatedLeaveData);
  }, [leaveCategoryList, userList, leaveCatgeory, availableLeaves]);

  const openDetailWindow = (name, id) => {
    setSelectedLeaveTypeId(id);
    setSelectedLeaveType(`Department's ${name} Balance`);

    toggleStaffDepartmentLeaveModal(true);
  };
  useEffect(() => {
    // getAvailableLeaves();
    getLeaveList();
    getLeaveListCategories();
  }, []);

  useEffect(() => {
    getData();
    getovertimeData();
    getTimeOffData();
  }, [requestMonth]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const getRequestDateRange = () => {
    const startDate = requestMonth
      ? dayjs(requestMonth.toDate()).startOf("month")
      : dayjs(dates.startDate);
    const endDate = requestMonth
      ? dayjs(requestMonth.toDate()).endOf("month")
      : dayjs(dates.endDate);
    return `startDate=${startDate.format("YYYY-MM-DD")}&endDate=${endDate.format(
      "YYYY-MM-DD"
    )}`;
  };

  const requestMonthFilter = (
    <DatePicker
      picker="month"
      format="MMM YYYY"
      placeholder="All months"
      style={{ width: 160 }}
      value={requestMonth}
      onChange={setRequestMonth}
      getPopupContainer={() => containerRef.current}
    />
  );

  const ApproveOk = async (reason) => {
    return new Promise(async (resolve) => {
      await approveRejectCancelLeave2(5, reason, havingCancel);
      resolve();
    }).catch((err) => console.log("[ApproveOk] Error-->", err));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setLoading(true);
    ApproveOk();
  };

  useEffect(() => {
    getLeaveList();
  }, [type]);

  const getLeaveList = async () => {
    return new Promise(async (resolve, reject) => {
      setLeaveList([]);

      if (selectedDepartmentId) {
        setDisplayTaskLoader(true);
        const { code, leaves = [] } = await CALL_API(
          `leave-list/${ClientId}`,
          "post",
          {
            status_id: "4",
            department_id: [""],
            start_date: dates.startDate,
            end_date: dates.endDate,
            reportingmanager: userInfo?.userid,
            myteam: true,
          }
        );

        setDisplayTaskLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveList(
            leaves
              ?.filter((item) => item?.userid !== userInfo?.userid)
              .reverse()
          );

          resolve(leaves);
        } else {
          reject([]);
        }
      } else {
        reject();
      }
    });
  };

  const getLeaveListCategories = async () => {
    const userids = userList
      ?.filter((user) => user?.reportingmanager === userInfo?.userid)
      ?.map((val) => val?.userid);
    return new Promise(async (resolve, reject) => {
      setLeaveCatgeory([]);

      if (selectedDepartmentId) {
        toggleLeaveReportLoader(true);
        const { leaves } = await CALL_API(`employee/allleave`, "post", {
          clientid: ClientId,
          reportingmanager: userInfo?.userid,
        });
        toggleLeaveReportLoader(false);
        setLeaveCatgeory(leaves);

        resolve(leaves);
        // if (
        //   includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        // ) {
        //   setLeaveCatgeory(response);

        //   resolve(response);
        // } else {
        //   reject([]);
        // }
      } else {
        reject([]);
      }
    });
  };

  const approveRejectCancelLeave2 = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request
  ) => {
    return new Promise(async (resolve) => {
      const payload =   {
          userid: leaveDetails?.userid,
          departmentId: selectedDepartmentId,
          user_leave_id: leaveID,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        }
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          userid: leaveDetails?.userid,
          departmentId: selectedDepartmentId,
          user_leave_id: leaveID,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        setLoading(false);
        setIsModalOpen(false);
        updateSuccessModal({
          visibility: true,
          message: "Approved",
          Sucessicon: (
            <div className="d-flex justify-content-center align-itemw-center">
              <CheckCircleFilled style={{ color: "green" }} />
            </div>
          ),
        });
        getLeaveList();
                  try {
          await fetch(`${N8N_URL}foresyts-approval-check`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
        } catch (error) {
          console.log("[Webhook] Error:", error);
        }
      } else {
        message.error(`Something went wrong. Please try again.`);
      }
      resolve();
    });
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 10,
    showSizeChanger: false,
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
    },

    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Start Date - Day",
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          const dateFormat = moment(record.start_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.start_date).format("dddd");
          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_start_date).format(
            "DD MMM YYYY"
          );
          const getdayAlone = moment(record.new_start_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },

    {
      title: "End Date - Day",
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          const dateFormat = moment(record.end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.new_end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },
    {
      title: "Days",
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "7%",
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "" ||
          record.new_number_of_days === "null"
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
    {
      title: "Reliever Name",
      dataIndex: "relievername",
      key: "relievername",
      width: "10%",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Leave Type",
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
    },
    {
      title: "Amended Leave",
      dataIndex: "having_cancel_request",
      key: "having_cancel_request",
      width: "10%",

      render: (having_cancel_request) => {
        if (having_cancel_request === "1") {
          return "Yes";
        } else {
          return "No";
        }
      },
    },
    {
      title: "Applied On",
      dataIndex: "created_at",
      key: "created_at",
      width: "10%",
      render: (_, record) => {
        const dateFormat = moment(record.created_at).format("DD MMM YYYY");

        return `${dateFormat}`;
      },
    },
  ];

  // if (
  //   Menulist?.find(
  //     (item) =>
  //       item?.key === "allapprovals" &&
  //       item?.subMenu?.find(
  //         (subItem) => subItem?.key === "approvals" && subItem?.permission.edit
  //       )
  //   )
  // ) {
  //   columns.push({
  //     title: "Action",
  //     dataIndex: "address",
  //     key: "address",
  //     width: "10%",
  //     render: (_, record) => (
  //       <>
  //         <Tooltip title="View Leave">
  //           <EyeFilled
  //             className="action-button"
  //             onClick={() => viewLeave(record, true)}
  //           />
  //         </Tooltip>
  //         {(userRoleId === 1 || userRoleId === 6) && (
  //           <Tooltip title="Remind HOD & Assistant HOD" placement="left">
  //             <BellFilled
  //               className="action-button"
  //               onClick={() => remindSuperior(record)}
  //             />
  //           </Tooltip>
  //         )}
  //       </>
  //     ),
  //   });
  // }

  const departmentOptions = concat(
    orderBy(filterDepartment, [(val) => val.department_id], ["asc"]).map(
      (dept) => ({
        value: dept.department_id,
        label: dept.department_name,
      })
    )
  );

  const filterleavereport = selectedDepartment
    ? leaveList.filter((item) => item.status_id === "4")
    : leaveList;

  const handleChange = (value) => {
    setSelectedDepartment(value);
  };

  useEffect(() => {
    setSelectedDepartment(null);
  }, []);

  const viewLeave = (leaveObject, isViewOnly = false) => {
    toggleDisplayLeaveModal(true);
    setLeaveDetails({
      ...leaveObject,
      isViewOnly,
    });
  };

  const remindSuperior = (leaveRecord) => {
    const { confirm } = Modal;
    confirm({
      icon: "",
      closable: true,
      content:
        "Do you want to send reminder notification to HOD & Assistant HOD?",
      async onOk() {
        const { user_leave_id, user_id } = leaveRecord;
        const { code } = await CALL_API(
          "leave-notification-to-hod-assistant-hod",
          "post",
          {
            user_leave_id,
            user_id,
          }
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success(`Notification has been sent.`);
        } else {
          message.error(`Something went wrong. Please try again.`);
        }
      },
      onCancel() {},
    });
  };

  const CSVHeaders = [
    { label: "Employee ID" },
    { label: "Name" },
    { label: "Available Leaves" },
    { label: "Consumed Leaves" },
    { label: "Total Leaves" },
  ];
  const prepareCSV = async (event, done) => {
    if (userLeaves.length > 0) {
      setCSVDepartmentLeave(
        reduce(
          userLeaves?.filter((value) => {
            const available =
              value.data.find((item) => item.type === "available")?.value || 0;
            const consumed =
              value.data.find((item) => item.type === "consumed")?.value || 0;
            return available !== 0 || consumed !== 0;
          }),
          function (result, leave) {
            result.push({
              "Leave Category ID": leave.id,
              "Leave Category Name": leave.categoryName,
              "Available Leaves": leave.data[0].value,
              "Consumed Leaves": leave.data[1].value,
              CF: leave.data[0].carryforward,
              // "Total Leaves": leave.data[0].value,
            });
            return result;
          },
          []
        )
      );

      setTimeout(() => {
        csvLinkDepartment.current.link.click();
      });
    } else {
      console.log("No data available to download");
    }
  };

  const onChange = (key) => {
    setTabId(key);
    console.log("Tab switched to:", key);
  };
  const items = [
    {
      key: "1",
      label: "Leave",
    },
    {
      key: "2",
      label: "Overtime",
    },
    {
      key: "3",
      label: "WFH",
    },
    {
      key: "4",
      label: "Time Off in Lieu",
    },
  ];

  return (
    <>
      <>
        <StyledRow gutter={16}>
          <Col md={24} sm={24} xs={24} xl={12}>
            <AttendanceBarChart filterdate={filterdate}/>
          </Col>

          <Col md={24} sm={24} xs={24} xl={12}>
            <LocationBasedPresentStaff filterdate={filterdate}/>
          </Col>

          <Col
            md={24}
            sm={24}
            xs={24}
            xl={24}
            ref={containerRef}
            className="mt-4"
          >
            <StyledChartContainer>
              <Tabs
                defaultActiveKey={tabId}
                items={items}
                onChange={onChange}
              />
              {tabId === "1" &&
                Menulist?.find(
                  (item) =>
                    item?.key === "allapprovals" &&
                    item?.subMenu?.find(
                      (subItem) =>
                        subItem?.key === "approvals" && subItem?.permission.view
                    )
                ) && (
                  <>
                    <StyledTitle>
                      Waiting for Approval {`(${filterleavereport?.length})`}
                    </StyledTitle>
                    {/* <StyledForm
                    form={form}
                    name="approval_form"
                    layout="inline"
                    initialValues={{
                      department_id: departmentOptions.length > 0 ? departmentOptions[0].value : '',
                    }}
                  >
                    <Select
                      className="select"
                      name="department_id"
                      placeholder={
                        <>
                          <img src={Filter} alt="filter" />{" "}
                          <span className="Status-placeholder">Department</span>
                        </>
                      }
                      options={departmentOptions}
                      onChange={handleChange}
                      value={selectedDepartment}
                      getPopupContainer={() => containerRef.current}
                    />
                  </StyledForm> */}

                    <Spin spinning={displayTaskLoader}>
                      <StyledTable
                        dataSource={filterleavereport}
                        columns={columns}
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? "" : "non-white"
                        }
                        onRow={(record) => {
                          return {
                            onClick: () => {
                              if (
                                Menulist?.find(
                                  (item) =>
                                    item?.key === "allapprovals" &&
                                    item?.subMenu?.find(
                                      (subItem) =>
                                        subItem?.key === "approvals" &&
                                        subItem?.permission.edit
                                    )
                                )
                              ) {
                                viewLeave(record, true);
                              }
                            },
                          };
                        }}
                        rowKey="user_leave_id"
                        pagination={
                          filterleavereport.length > 10
                            ? paginationOptions
                            : false
                        }
                      />
                    </Spin>
                  </>
                )}
              {tabId === "2" && (
                <>
                  <div className="d-flex align-items-center">
                    <StyledTitle>
                      Waiting for Approval {`(${overtimedata?.length})`}
                    </StyledTitle>
                    {requestMonthFilter}
                  </div>
                  <StyledTable
                    columns={overtimecolumns}
                    dataSource={overtimedata}
                    pagination={
                      overtimedata?.length > 10 ? paginationOptions : false
                    }
                    rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
                  />
                </>
              )}
              {tabId === "3" && (
                <>
                  <div className="d-flex align-items-center">
                    <StyledTitle>
                      Waiting for Approval {`(${data?.length})`}
                    </StyledTitle>
                    {requestMonthFilter}
                  </div>
                  <StyledTable
                    columns={workFromHomecolumns}
                    dataSource={data}
                    pagination={data?.length > 10 ? paginationOptions : false}
                    rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
                  />
                </>
              )}
              {tabId === "4" && (
                <>
                  <div className="d-flex align-items-center">
                    <StyledTitle>
                      Waiting for Approval {`(${timeOffData?.length})`}
                    </StyledTitle>
                    {requestMonthFilter}
                  </div>
                  <StyledTable
                    columns={timeOffColumns}
                    dataSource={timeOffData}
                    pagination={
                      timeOffData?.length > 10 ? paginationOptions : false
                    }
                    rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
                  />
                </>
              )}
              <LeaveFormModel
                isModalVisible={displayLeaveModal}
                closeModal={() => toggleDisplayLeaveModal(false)}
                userRoleId={userRoleId}
                leaveDetails={leaveDetails}
                toggleDisplayLeaveModal={toggleDisplayLeaveModal}
                getLeaveList={getLeaveList}
                setIsModalOpen={setIsModalOpen}
                setLeaveID={setLeaveID}
                sethavingCancel={sethavingCancel}
                ClientId={ClientId}
              />
            </StyledChartContainer>
          </Col>

          <Col md={24} sm={24} xs={24} xl={24} className="mt-4">
            <Spin spinning={displayLeaveReportLoader}>
              <StyledLeaveRow gutter={24}>
                <Col span={12}>
                  <div>
                    <StyledTitle>Overall Leave Report</StyledTitle>
                  </div>
                </Col>
                <Col
                  span={12}
                  className="leavereportstyle"
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  <ButtonOutlined
                    onClick={prepareCSV}
                    disabled={userLeaves.length === 0}
                  >
                    Export CSV file
                  </ButtonOutlined>
                  <CSVLink
                    header={CSVHeaders}
                    data={CSVDepartmentLeave}
                    filename={"Overall Leave Report.csv"}
                    asyncOnClick={true}
                    ref={csvLinkDepartment}
                  />
                </Col>
                {Array.isArray(leaveSummary) &&
                  leaveSummary
                    ?.filter((value) => {
                      const available =
                        value.data.find((item) => item.type === "available")
                          ?.value || 0;
                      const consumed =
                        value.data.find((item) => item.type === "consumed")
                          ?.value || 0;
                      return available !== 0 || consumed !== 0;
                    })
                    .map((value) => (
                      <Col
                        md={24}
                        sm={24}
                        xs={24}
                        xl={12}
                        key={value.categoryName}
                        className="mt-2"
                      >
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            openDetailWindow(value.categoryName, value.id);
                          }}
                        >
                          <LeaveDonutChart
                            iconName={LEAVE_ICON[7]}
                            title={`${value.categoryName} - ${new Date()
                              .getFullYear()
                              .toString()}`}
                            isRollout={value}
                            data={value.data}
                            leaveId={value?.id}
                          />
                        </div>
                      </Col>
                    ))}
              </StyledLeaveRow>
            </Spin>
          </Col>
        </StyledRow>
      </>

      <Modal
        title="Approve leave"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to approve leave?</p>
      </Modal>

      <DepartmentStaffLeaveBalance
        displayModal={staffDepartmentLeaveModal}
        toggleModal={() => toggleStaffDepartmentLeaveModal(false)}
        leaveTypeId={selectedLeaveTypeId}
        selectedDepartmentId={selectedDepartmentId}
        leaveName={selectedLeaveType}
        // leaveList={leaveList}
        leaveCategoryList={leaveCategoryList}
        filterDepartment={filterDepartment}
        leaveCatgeory={leaveCatgeory}
        availableLeaves={availableLeaves}
      />
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </>
  );
}

export default ManagerDashboard;
